import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { Vue3Mq } from "vue3-mq";
import "animate.css";
import "tw-elements";

import "./index.css";
require("@lottiefiles/lottie-player");

createApp(App).use(router).use(createPinia()).use(Vue3Mq).mount("#app");
